import { Roles } from '@/lib/auth/roles/roles.type';
import { useUserHasRole } from '@/lib/auth/useUserHasRoles';
import { appData } from '@/lib/data';
import {
  useGetCurrentTenantProfileQuery,
  useGetNavigationsQuery,
} from '@/modules/services';
import { Menu as ElmoMenu, PlaceholderMenu } from 'elmo-elements';
import React, { ReactElement, useMemo } from 'react';
import './styles.scss';
import { useNavigationSubmenu } from '@/lib/hooks';
import { MenuNext } from './MenuNextView';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useHistory } from 'react-router-dom';

const Menu: React.FC = (): ReactElement => {
  const isCompanyAdmin = useUserHasRole([Roles.CAdmin]);
  const history = useHistory();
  const tenant = useGetCurrentTenantProfileQuery();
  const { data: navigationData, isLoading: isNavigationLoading } =
    useGetNavigationsQuery();
  const { navigationSubmenu } = useNavigationSubmenu({
    tenantData: tenant.data,
  });

  // Using LaunchDarkly flag with key frontend-new-left-nav-ui-learning -> frontendNewLeftNavUiLearning
  const { frontendNewLeftNavUiEla: isNextMenuEnabled } = useFlags();

  const appCourseBuilderMenu = useMemo(
    () =>
      navigationData?.menu.modules.find(
        (module) => module.key === appData.menu.appCourseBuilderKey,
      ),
    [navigationData],
  );

  if (isNavigationLoading || !navigationData || isCompanyAdmin === undefined) {
    return <PlaceholderMenu />;
  }

  const navigationInfo = {
    ...navigationData,
    menu: {
      ...navigationData.menu,
      modules: navigationData.menu.modules.map((module) => {
        if (module.key === appData.menu.appCourseBuilderKey) {
          return {
            ...module,
            isSelected: true,
            subItems: navigationSubmenu.map((submenuItem) => ({
              ...submenuItem,
              isCurrentPage: Boolean(submenuItem.isSelected),
              onClick: () => {
                if (submenuItem.handleClick) {
                  submenuItem.handleClick();
                } else history.push(submenuItem.url);
              },
            })),
          };
        }
        return module;
      }),
    },
  };

  return (
    <div className="ela-menu">
      {isNextMenuEnabled ? (
        <MenuNext navigationData={navigationInfo} />
      ) : (
        <ElmoMenu
          asSubMenu={!!appCourseBuilderMenu}
          isLoading={isNavigationLoading}
          isReact
          logo={navigationData.branding.logo}
          menuItems={navigationData.menu.modules}
          subMenuItems={navigationSubmenu}
          theme={navigationData.branding.theme}
          userDetails={{
            name: navigationData.user.name,
            avatar: navigationData.user.img,
            isAdmin: isCompanyAdmin,
            adminUrl: navigationData.menu.user.find(
              (menuItem) => menuItem.key === 'app.menu.admin',
            )?.url,
          }}
          userMenu={navigationData.menu.user}
        />
      )}
    </div>
  );
};

export default Menu;
